import { Flower2 } from "lucide-react";

const WORDS = ["Respira", "Nutri", "Senti", "Presenza", "Leggerezza", "Radicamento", "Ascolto", "Armonia"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="mx-8 font-serif text-3xl italic text-sage-deep/70 sm:text-4xl">{w}</span>
        <Flower2 className="h-4 w-4 text-lavanda/60" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-sage/10 bg-cream-soft py-8" aria-hidden="true">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
